import { API_BASE, apiFetch, authHeaders, parseApiError } from './apiClient';

export async function fetchZones() {
  const response = await apiFetch(`${API_BASE}/zones`, {
    headers: authHeaders(),
  });
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(parseApiError(payload, 'No se pudieron cargar las zonas'));
  }
  return Array.isArray(payload) ? payload : [];
}

export async function fetchZone(id) {
  const response = await apiFetch(`${API_BASE}/zones/${encodeURIComponent(id)}`, {
    headers: authHeaders(),
  });
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(parseApiError(payload, 'No se pudo cargar la zona'));
  }
  return payload;
}

export async function createZone(body) {
  const response = await apiFetch(`${API_BASE}/zones`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(body),
  });
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(parseApiError(payload, 'No se pudo crear la zona'));
  }
  return payload;
}

export async function updateZone(id, body) {
  const response = await apiFetch(`${API_BASE}/zones/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    headers: authHeaders(),
    body: JSON.stringify(body),
  });
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(parseApiError(payload, 'No se pudo actualizar la zona'));
  }
  return payload;
}

export async function deleteZone(id) {
  const response = await apiFetch(`${API_BASE}/zones/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    headers: authHeaders(),
  });
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(parseApiError(payload, 'No se pudo eliminar la zona'));
  }
  return payload;
}
